import { PopupReturnTypeWithPayload } from '../../../../hooks/usePopup'
import {
  AddToMyVendorsPopupPayload,
  TVendorList,
  UpgradeToFullAccessPopupPayload
} from '../VendorsList/types'
import { initialPopup } from '../../../../hooks/constants'

export const addToMyVendorsPopupWithPayload: PopupReturnTypeWithPayload<AddToMyVendorsPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: { vendor: {} as TVendorList }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export const upgradeToFullAccessPopupWithPayload: PopupReturnTypeWithPayload<UpgradeToFullAccessPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: { uuid: '' }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }
